export default "__VITE_ASSET__ff670493__"